export function setRaiGlobalProperty<T = any>(key: string, value: T): T {
  const Rai = window.Rai ?? {} as Rai;
  Rai[key as keyof Rai] = value as any;
  return value;
}

export function getRaiGlobalProperty<T>(name: string) {
  return window.Rai?.[name as keyof Rai] as T;
}

export function getStringOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (userAgent) {
    if (/android/i.test(userAgent)) {
      return 'android'
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'ios';
    }
  }

  return 'web';
}

export function isInIframe() {
  return top !== self;
}

const COOKIE = 'cookie';
let isSupported: boolean;

hasCookies();

function hasCookies() {
  if (typeof isSupported !== 'undefined') {
    return isSupported;
  }
  const tmp = COOKIE + COOKIE;
  try {
    cookie(tmp, tmp);
    isSupported = document.cookie.indexOf(tmp) !== -1;
    removeCookie(tmp);
  } catch {
    isSupported = false;
  }
  return isSupported;
}

function cookie(name: string, value?: any, ttl?: number, path?: string, domain?: string, secure?: boolean) {
  if (typeof window === 'undefined') {
    return
  }
  const isSet = arguments.length > 1;
  if (isSupported === false) { return }
  if (isSet) {
    return (document.cookie = name + '=' + encodeURIComponent(value) +
      ((!ttl) ? '' : '; expires=' + new Date(+new Date() + (ttl * 1000)).toUTCString() +
      ((!path) ? '' : '; path=' + path) +
      ((!domain) ? '' : '; domain=' + domain) +
      ((!secure) ? '' : '; secure'))
    );
  }
  return decodeURIComponent((('; ' + document.cookie).split('; ' + name + '=')[1] || '').split(';')[0]);
}

function removeCookie(name: string) {
  if (isSupported) {
    cookie(name, '', -1)
  }
}

export const utils = {
  cookie: {
    get: cookie,
    set: cookie,
    remove: removeCookie
  }
}
